"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var JSONCondition = (function () {
    function JSONCondition(json, value) {
        var _this = this;
        this.complieAtom = function (source) {
            if (source === void 0) { source = []; }
            switch (source[0]) {
                case '&&':
                    return source.slice(1).every(_this.complieAtom);
                case '||':
                    return source.slice(1).some(_this.complieAtom);
                case '>':
                    return Number(_this.value) > Number(source[1]);
                case '<':
                    return Number(_this.value) < Number(source[1]);
                case '>=':
                    return Number(_this.value) >= Number(source[1]);
                case '<=':
                    return Number(_this.value) <= Number(source[1]);
                case '=':
                case '==':
                    return shared_1.isEqual(_this.value, source[1]);
                case '!=':
                    return !shared_1.isEqual(_this.value, source[1]);
                case '!':
                    return !_this.value;
                case 'includes':
                    if (shared_1.isArr(_this.value)) {
                        return _this.value.indexOf(source[1]) > -1;
                    }
                    return String(_this.value).includes(source[1]);
                case 'pattern':
                    return new RegExp(source[1]).test(_this.value);
                case 'startWith':
                    return String(_this.value).startsWith(source[1]);
                case 'endWith':
                    return String(_this.value).endsWith(source[1]);
            }
            return false;
        };
        this.source = json || [];
        this.value = value;
    }
    JSONCondition.prototype.complie = function () {
        return this.complieAtom(this.source);
    };
    JSONCondition.calculate = function (condition, value) {
        if (shared_1.isArr(condition)) {
            return new JSONCondition(condition, value).complie();
        }
        if (shared_1.isBool(condition))
            return condition;
        return false;
    };
    return JSONCondition;
}());
exports.JSONCondition = JSONCondition;
